<template>
	<div class="face-wrap">
		<img class="face" :src="face" />
		<img class="ico-v" v-if="grade == 1" :src="icon" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import img_v from '@/assets/image/users/ico_v.png'

export default {
	name: 'UserFace',
	data() {
		return {
			icon: img_v
		}
	},
	computed: {
		...mapGetters([
			'face', 'grade'
		])
	}
}
</script>

<style lang="scss" scoped>
.face-wrap {
	position: relative;
}
.face {
	width: 100%;
	height: 100%;
	border-radius: 100%;
}
.ico-v {
	position: absolute;
	width: 30%;
	height: 30%;
	right: 0;
	bottom: 0;
}
</style>
